import React from 'react';
import SarDefaultInfoButton from './SarDefaultInfoButton';

const DefaultHeaderDetails = ({ hasError = false, label, itemLabelClassName }: Props) => {
  return (
    <div className={`${itemLabelClassName} flex flex-col gap-y-1`}>
      <div className={'flex items-center gap-x-1 justify-start'}>
        <span className={`text-xs tracking-wide text-f-black-2 ${hasError ? 'text-f-red-1' : ''}`}>Information</span>
        <SarDefaultInfoButton hasError={hasError} onStopPropagation={(event) => event.stopPropagation()} />
      </div>
      <span className={`text-sm font-medium text-[#1D2939] ${hasError ? 'text-f-red-1' : ''}`}>{label}</span>
    </div>
  );
};

interface Props {
  label: string;
  itemLabelClassName: string;
  hasError?: boolean;
}

export default DefaultHeaderDetails;
